import {
  API_ENDPOINT,
  useClientApiV1NotesIdWithUnitsQuery,
} from '../../../../../../resources/@types/uccSchema';
import { generateQueryKeyUrl } from '../../../../../utils/generateQueryKeyUrl';

interface UseNoteIdWithUnitsQueryParams {
  id: string;
}

function useNoteIdWithUnitsQuery(
  params: UseNoteIdWithUnitsQueryParams,
  options?: Parameters<typeof useClientApiV1NotesIdWithUnitsQuery>[0]['options'],
) {
  const { id, ...queryParams } = params;

  const result = useClientApiV1NotesIdWithUnitsQuery({
    ...generateQueryKeyUrl({
      url: API_ENDPOINT.CLIENT_V1_NOTES_ID_WITH_UNITS(params.id),
      queryParams: queryParams,
    }),
    options: {
      staleTime: Infinity,
      ...options,
    },
  });
  if (result.data) {
    result.data = {
      ...result.data,
      sections: result.data.sections.map((section) => ({
        ...section,
        units: section.units.map((unit) => {
          return {
            ...unit,
            notes: unit.notes.map((note) => {
              return {
                ...note,
                body: supportLegacyEditorImg(note.body),
              };
            }),
          };
        }),
      })),
    };
  }
  return result;
}

// NOTE: 과거 에디터로 이미지를 추가했을 때 <p>태그안에 <img> 태그가 생겨, 최근 에디터로 수정하면 이미지가 날라가는 버그를 방지하기 위함. 추후에는 삭제할 것
function supportLegacyEditorImg(content: string) {
  return content
    .replace(/<p>\s*(<img[^>]+>)\s*<\/p>/gs, '$1') // img 태그만 있는 <p> 제거
    .replace(/<p>\s*(<img[^>]+>)\s*(.*?)<\/p>/gs, '$1\n<p>$2</p>'); // img + 다른 텍스트 처리
}

export const getUseNoteIdWithUnitsQueryKey = (id: string) => [
  API_ENDPOINT.CLIENT_V1_NOTES_ID_WITH_UNITS(id),
];

export default useNoteIdWithUnitsQuery;
